import { useEffect, useState } from "react";
import config from "../config.js";

export default function CycleStatusView({ cycleId, loadInfo }) {
  const [localLoadInfo, setLocalLoadInfo] = useState(loadInfo || null); // start as null

  const getPerformanceData = async () => {
    try {
      const response = await fetch(
        `${config.apiPath}/performance_process/performance_status_api.php`,
        {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ cycle_id: cycleId }),
        }
      );

      const data = await response.json();

      if (data.status === "error" && data.errMsg === "Invalid Loign Data") {
        window.location.href = `/${config.appPath}`;
      } else if (data.status === "success" && data.load_info) {
        setLocalLoadInfo(data.load_info);
      }
    } catch (error) {
      console.error(`Failed to fetch performance data for cycle ${cycleId}:`, error);
    }
  };

  // when parent sends initial data
  useEffect(() => {
    if (loadInfo) setLocalLoadInfo(loadInfo);
  }, [loadInfo]);

  // auto-refresh every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      if (document.visibilityState === "visible") {
        getPerformanceData();
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [cycleId]);

  
  // safely extract data
  const percentage = Number(localLoadInfo?.percentage || 0);
  const display_percentage = Number(localLoadInfo?.display_percentage || 0);

  const steps = [
    { label: "Test Setup", start: 0, end: 25, process: localLoadInfo?.setup_process },
    { label: "AI Data", start: 25.1, end: 50, process: localLoadInfo?.ai_data_process },
    { label: "Test Run", start: 50.1, end: 75, process: localLoadInfo?.cycle_process },
    { label: "Report", start: 75.1, end: 100, process: localLoadInfo?.report_process },
  ];

  const getSegmentColor = (step) => {
    if (percentage < step.start) return "bg-blue-200";
    if (percentage >= step.end) return "bg-blue-700";
    return "bg-blue-500";
  };

  function ProcessStatus({ process, percentage }) {
    if (process === "completed") return <>Done</>;
    if (process === "started") return <>{percentage}% completed</>;
    return <>Not Started</>;
  }

  return (
    <div className="rounded-md dark:border-white/20 mt-2">
      <div aria-hidden="true">

         {/* Step Labels */}
        <div className="mb-2 grid grid-cols-4 text-sm font-medium text-gray-600 dark:text-gray-400">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`text-center ${percentage >= step.start ? "text-indigo-600 dark:text-indigo-400" : ""}`}
            >
              {step.label} - {" "}
              <ProcessStatus
                process={step.process}
                percentage={display_percentage.toFixed(1)}
              />
            </div>
          ))}
        </div>

        
         <div className="flex gap-2">
  {steps.map((step, index) => {
    let fill = 0;

    if (percentage >= step.end) fill = 100;
    else if (percentage > step.start)
      fill = ((percentage - step.start) / (step.end - step.start)) * 100;

    return (
      <div
        key={index}
        className="relative flex-1 h-3 rounded-md overflow-hidden bg-gray-200 dark:bg-white/10"
      >
        <div
          className={`${getSegmentColor(step)} transition-all duration-300`}
          style={{ width: `${fill}%`, height: "100%" }}
        />
      </div>
    );
  })}
</div>
        
        

       
      </div>
    </div>
  );
}
